import { z } from "zod";

export const createMonthlyBudgetSchema = z.object({
  master_budget_id: z.string().uuid("Master budget is required"),
  title: z.string().trim().min(1, "Title is required"),
  description: z.string().optional(),
  month: z.string().regex(/^\d{4}-\d{2}$/, "Invalid month format"),
});

export type CreateMonthlyBudgetInput = z.infer<typeof createMonthlyBudgetSchema>;
